<div class="card-header">
    <div class="row">
        <div class="col-10">Seneste kunder</div>
        <div class="col-2 text-end"><i class="card-header__icon fa fa-address-card"></i></div>
    </div>
</div>

<div class="card-body">
    <div class="table-responsive">
        <table class="clientTable table table-hover table-striped table-sm">
            <tbody>
                <ng-container *ngFor="let recentClient of recentClients">
                    <tr *ngIf="recentClient?.recentClientDetails"
                    (click)="onSelectClient(recentClient)">
                        <td class="clientTable__number">{{recentClient?.recentClientDetails?.glkundenr}}</td>
                        <td>{{recentClient?.recentClientDetails?.navn1}}</td>
                        <td>{{recentClient?.recentClientDetails?.navn2}}</td>
                    </tr>
                </ng-container>
            </tbody>
        </table>
    </div>
</div>
